<kendo-appbar class="appbar" [class.appbar--non-prod]="showNonProdBanner" aria-live="assertive">
  <kendo-appbar-section class="title">
    <span *ngIf="showNonProdBanner" class="environment-banner-inline k-white-space-normal">
      NON-PRODUCTION ENVIRONMENT
      <span class="environment-banner-inline__separator">|</span>
      {{ nonProdEnvironmentLabel }}
    </span>
  </kendo-appbar-section>

  <kendo-appbar-spacer></kendo-appbar-spacer>
  <kendo-appbar-section *ngIf="isShowTopSearchBar()" class="search-section">
    <div kendoTooltip title="Search {{searchMode}} here">
      <kendo-label [for]="headerSearch" labelCssClass="k-sr-only" text="text ">
        <kendo-textbox #headerSearch class="search-container" placeholder="{{ getPlaceholderText() }}" [clearButton]="true"
          [(ngModel)]="searchText">
          <ng-template kendoTextBoxPrefixTemplate>
            <kendo-dropdownlist aria-placeholder="Student" [(ngModel)]="searchMode" [data]="searchData"
              class="search-dropdown" size="large" rounded="large">
            </kendo-dropdownlist>
            <kendo-textbox-separator></kendo-textbox-separator>
          </ng-template>

          <ng-template kendoTextBoxSuffixTemplate>
            <div class="k-px-2">
              <button kendoButton [svgIcon]="searchIcon" size="small" themeColor="primary" fillMode="flat"
                (click)="search()" aria-label="Search"> </button>
            </div>
          </ng-template>
        </kendo-textbox>
      </kendo-label>
    </div>
  </kendo-appbar-section>

  <kendo-appbar-spacer width="24px"></kendo-appbar-spacer>
  <kendo-appbar-section class="user-actions mobile-search-action" *ngIf="isShowTopSearchBar()">
    <button class="helpIcon" kendoButton (click)="search()" title="Search" aria-label="Search" fillMode="flat"
      size="none">
      <fa-icon icon="magnifying-glass" size="2x"></fa-icon>
    </button>
  </kendo-appbar-section>
  <kendo-appbar-section class="user-actions" *ngIf="enableNotifications">
    <div class="notification-icon-wrapper">
      <div kendoPopoverAnchor [popover]="notificationInfo" showOn="none" #anchor="kendoPopoverAnchor">
        <kendo-badge-container>
          <button class="helpIcon" kendoButton (click)="togglePopover()" title="Recent Notifications"
            aria-label="Recent Notifications" fillMode="flat" size="none">
            <fa-icon icon="bell" size="2x"></fa-icon>
          </button>
          <kendo-badge themeColor="error" size="medium" position="inside" rounded="full" *ngIf="badgeCountToShow"
            [align]="{ vertical: 'top', horizontal: 'end' }"></kendo-badge>
        </kendo-badge-container>
      </div>
    </div>
  </kendo-appbar-section>
  <kendo-appbar-section class="user-actions">
    <button class="helpIcon" kendoButton (click)="openHelp()" title="Help" aria-label="Help" fillMode="flat"
      size="none">
      <fa-icon icon="circle-question" size="2x"></fa-icon>
    </button>
  </kendo-appbar-section>
  <kendo-appbar-section class="user-actions">
    <button class="helpIcon" kendoButton (click)="openReleaseNotes()" title="Release Notes" aria-label="Release Notes"
      fillMode="flat" size="none">
      <fa-icon icon="book" size="2x"></fa-icon>
    </button>
  </kendo-appbar-section>

  <div class="vertical-divider-user"></div>

  <kendo-appbar-section>
    <div #userSection [ngClass]="{'user-info-section-open': userInfoSectionOpen}"
      class="k-d-flex k-align-items-center user-info-section"
      tabindex="0"
      role="button"
      aria-haspopup="menu"
      aria-label="User Profile"
      (keydown.enter)="userSection.click()"
      (keydown.space)="$event.preventDefault(); userSection.click()">
      <kendo-avatar initials="{{ user?.firstName?.charAt(0) }}{{ user?.lastName?.charAt(0) }}"
        size="medium"></kendo-avatar>
      <div class="user-info-container">
        <div class="user-name k-font-bold">
          <div>
            <div>
              <span *ngIf="authStore.isImpersonating()">{{user?.actor}} on behalf of </span> {{ user?.firstName }} {{
              user?.lastName }}
            </div>
            <div class="k-font-normal">
              {{
              user?.selectedRole?.roleDescription ||
              user?.selectedRole?.roleName
              }}
            </div>
          </div>
        </div>
      </div>
      <fa-icon class="k-ml-4" icon="chevron-down" size="1x"></fa-icon>
    </div>
  </kendo-appbar-section>
</kendo-appbar>
<kendo-contextmenu [target]="userSection" [items]="items" showOn="click" (select)="selectUserAction($event)"
  (popupOpen)="userInfoSectionOpen = true" (popupClose)="userInfoSectionOpen = false">
  <ng-template kendoMenuItemTemplate let-item="item">
    <fa-icon *ngIf="item.icon" [icon]="item.icon" size="1x"></fa-icon>
    {{ item.text }}
  </ng-template>
</kendo-contextmenu>

<app-student-search [showSearchModal]="(showNewReferralModal$ | async)!" [newReferral]="isNewReferral"
  [showCreateStudentBtn]="true" [searchText]="searchText" (closeModal)="closeModalHandler()">
</app-student-search>

<kendo-popover #notificationInfo [width]="636" position="bottom" [callout]="false">
  <ng-template kendoPopoverTitleTemplate>
    <div>
      <h4>Recent Notifications</h4>
    </div>
  </ng-template>

  <ng-template kendoPopoverBodyTemplate>
    <app-loader [hideLoader]="loading$ | async"></app-loader>
    <div class="popover-body">
      <kendo-tabstrip [tabAlignment]="alignment" size="large" (tabSelect)="onSelect($event)" aria-label="Notifications">
        <kendo-tabstrip-tab [selected]="true">
          <ng-template kendoTabTitle>
            <strong>Action Required</strong>
            <span class="tabstrip-count">{{actionRequiredLength}}</span>
          </ng-template>
          <ng-template kendoTabContent>
            <app-notification-content [content]="actionRequired"></app-notification-content>
          </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab [selected]="false">
          <ng-template kendoTabTitle>
            <strong>Informational</strong>
            <span class="tabstrip-count">{{informationalLength}}</span>
          </ng-template>
          <ng-template kendoTabContent>
            <app-notification-content [content]="informational"></app-notification-content>
          </ng-template>
        </kendo-tabstrip-tab>
      </kendo-tabstrip>
    </div>
  </ng-template>

  <ng-template kendoPopoverActionsTemplate>
    <div class="k-d-flex k-justify-conetent-start notification-actions">
      <button kendoButton fillMode="flat" themeColor="primary"
        *ngIf="(actionRequired?.length && selectedTabIndex === 0 || informational?.length && selectedTabIndex === 1)"
        (click)="markAllAsDone(selectedTabIndex)">
        {{selectedTabIndex === 0 ? 'Mark Above as Done' : 'Mark Above as Read'}}
      </button>
      <button kendoButton fillMode="flat" themeColor="primary" (click)="viewAllNotifications()">
        View All
      </button>
    </div>
  </ng-template>
</kendo-popover>

<ng-template #impersonationTemplate>
  <div class="impersonation-content k-d-flex k-gap-6 k-my-1 k-mx-2">
    <h6 class="!k-m-0">Currently Impersonating: {{ user?.firstName }} {{ user?.lastName }} - {{
      user?.selectedRole?.roleDescription ||
      user?.selectedRole?.roleName }}</h6>
    <div class="vertical-divider"></div>
    <div class="k-text-underline k-cursor-pointer k-font-semibold stop-btn" (click)="stopImpersonation()">
      Stop Impersonation Session
    </div>
  </div>
</ng-template>

<!-- Impersonate User Dialog -->
@if(displayImpersonateUserDialog$ | async){
<app-impersonate-user (closeImpersonateDialog)="displayImpersonateUserDialog$.next(false)"></app-impersonate-user>
}